import React from "react";
import { useSelector } from "react-redux";
import SessionEndModal from "../../components/Enrollment/SessionEndModal";
import PagePathConstants from "../../constants/page-numbers";
import ActivateCard from "../Enrollment/ActivateCard.tsx";

const CardDetails = () => {
  const userData = useSelector((state) => state.enrollment.userData);
  const currentPage = useSelector((state) => state.enrollment.currentPage);

  if (currentPage !== PagePathConstants.CARD_DETAILS) {
    return null;
  }

  return (
    <div className="">
      <ActivateCard isEnrollment={true} currentPage={currentPage} enrollmentData={userData} />
      <SessionEndModal />
    </div>
  );
};

CardDetails.displayName = "CardDetailsComponent";

export default CardDetails;
